var $ = require( 'jquery' );

import inview from 'jquery-inview/jquery.inview';
import 'slick-carousel';


$(document).ready(function() {
	imageSlider();
});

$(window).resize(function() {
    var stHeight = $('.slick-track').height();
    $('.slick-slide').css('height',stHeight + 'px' );
})

var slideshowImages = $( ".content-with-image__slider:visible" );
function imageSlider() {
    if (slideshowImages.length) {
        slideshowImages.bind( 'inview', function( event, visible ) {
            if ( visible == true ) {
                slideshowImages.not('.slick-initialized').slick({
                    dots: true,
                    arrows: false,
                    lazyLoad: 'ondemand',
                    infinite: true,
                    autoplay: true,
                    rows: 0,
                    autoplaySpeed: 4000,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    pauseOnHover: false,
                    adaptiveHeight: true,
                    pauseOnFocus: false,
                    swipeToSlide: true,
                });
    
                var stHeight = $('.slick-track').height();
                $('.slick-slide').css('height',stHeight + 'px' );
            }
        });
    }
   
}